export default {
    name: 'SpaRouterView'
};
